import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ResidentialPage = lazy(() => import('../pages/residential/page'));
const CommercialPage = lazy(() => import('../pages/commercial/page'));
const FinancingPage = lazy(() => import('../pages/financing/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/residential',
    element: <ResidentialPage />,
  },
  {
    path: '/commercial',
    element: <CommercialPage />,
  },
  {
    path: '/financing',
    element: <FinancingPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;